import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Menu } from 'react-feather';
import { MainLogoWhite } from '../MainLogo';

const primary = '#25a7c6';
const white = '#fff';

const TopBar = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 56px;
  background: ${primary};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  z-index: 1030;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  @media (min-width: 768px) {
    display: none;
  }
`;

const HamburgerButton = styled.button`
  background: transparent;
  border: 1px solid ${white};
  color: ${white};
  padding: 8px 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 4px;
  font-size: 14px;

  &:hover,
  &:focus {
    background: rgba(255, 255, 255, 0.1);
  }
`;

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;

  img {
    max-height: 32px;
  }
`;

const MobileTopBar = ({ onMenuClick }) => (
  <TopBar>
    <LogoWrapper>
      <MainLogoWhite />
    </LogoWrapper>
    <HamburgerButton type="button" onClick={onMenuClick}>
      <Menu size={24} />
      Menú
    </HamburgerButton>
  </TopBar>
);

MobileTopBar.propTypes = {
  onMenuClick: PropTypes.func.isRequired
};

export default MobileTopBar;
